import t from "@/lang/lang";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  ProcessPage,
  ProcessPageMain,
} from "@/shared/bsm/core/process/components/ui/process-page";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { ReactNode } from "react";
import { useParams } from "react-router";

export function ProcessConfiguredGuard({
  children,
  serviceObjectsRequired = true,
}: {
  children: ReactNode;
  serviceObjectsRequired?: boolean;
}) {
  const { processId } = useParams();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  if (data) {
    if (
      data.customerId &&
      data.branches.length > 0 &&
      (!serviceObjectsRequired || data.serviceObjects.length > 0)
    ) {
      return children;
    }
  }

  return (
    <ProcessPage>
      <ProcessPageMain className="px-4 pt-20">
        <Alert>
          <AlertTriangle />
          <AlertTitle>{t("Vorgang nicht eingerichtet")}</AlertTitle>
          <AlertDescription>
            {t(
              "Der Vorgang ist nicht vollständig eingerichtet. Bitte navigieren Sie zur Übersicht und setzen alle Felder.",
            )}
          </AlertDescription>
        </Alert>
      </ProcessPageMain>
    </ProcessPage>
  );
}
